<template>
    <b-container fluid>
        <!-- Search Form -->
        <iq-card>
            <template v-slot:headerTitle>
                 <h4 class="card-title">{{ $t('grant_budget_management.budget_approval') }}</h4>
            </template>
            <template v-slot:body>
                <b-row>

                     <b-col xl="5" lg="5" md="5" sm="12" xs="12">
                        <b-form-group
                            class="row"
                            label-cols-md="5"
                            :label="$t('grant_budget_management.organization')"
                            label-for="org_id"
                        >
                            <b-form-select
                                plain
                                v-model="search.org_id"
                                :options="organizationList"
                                id="org_id"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col xl="5" lg="5" md="5" sm="12" xs="12">
                        <b-form-group
                            class="row"
                            label-cols-md="5"
                            :label="$t('grant_budget_management.fiscal_year')"
                            label-for="fiscal_year_id"
                        >
                            <b-form-select
                                plain
                                v-model="search.fiscal_year_id"
                                :options="fiscalYearList"
                                id="fiscal_year_id"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xl="2" lg="2" md="2" sm="12" xs="12">
                        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
        <!-- /Search Form -->

        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('grant_budget_management.budget_approval') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>

                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                                            <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                                        </template>

                                        <!-- Action -->
                                        <template v-slot:cell(action)="data">
                                            <!-- <b-button  v-if="data.item.process_status !== 3" :title="$t('grant_budget_management.modifiy_budget')" variant=" iq-bg-success mr-1 mb-1" size="sm">
                                                <router-link :to="{ path: '/grant-allowance-service/budget-management/budget-approval-update', query: { id: data.item.id }}"
                                                             class="iq-bg-success mr-1 mb-1" size="sm">
                                                    <i class="ri-ball-pen-fill m-0"></i>
                                                </router-link>
                                            </b-button>

                                            <b-button :title="$t('grant_budget_management.view_budget')" v-b-modal.modal-5 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>
                                            <b-button :title="$t('grant_budget_management.send')"  v-b-modal.modal-1 variant=" iq-bg-success mr-1 mb-1" size="sm" v-if="$store.state.Auth.activeRoleId !== 1 && $store.state.Auth.authUser.user_id !== data.item.last_user_id && data.item.process_status !== 3" @click="view(data.item, 'send')"><i class="ri-share-forward-line m-0"></i></b-button>
                                            <b-button :title="$t('grant_budget_management.approve')" v-b-modal.modal-1 variant=" iq-bg-success mr-1 mb-1" size="sm" v-if="($store.state.Auth.activeRoleId === 1 || $store.state.Auth.authUser.user_id === data.item.last_user_id) &&  data.item.process_status !== 3" @click="view(data.item, 'approve')"><i class="ri-check-fill m-0"></i></b-button> -->
                                            <router-link :to="{ path: '/grant-allowance-service/budget-management/budget-approval-update', query: { id: data.item.id }}"
                                                class="btn_table_action btn_blue"><i class="ri-ball-pen-fill m-0"></i>
                                            </router-link>
                                            <a href="javascript:" class="btn_table_action btn_green" :title="$t('grant_budget_management.view_budget')" v-b-modal.modal-5 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                                            <a href="javascript:" class="btn_table_action btn_purple" :title="$t('grant_budget_management.send')"  v-b-modal.modal-1 v-if="$store.state.Auth.activeRoleId !== 1 && $store.state.Auth.authUser.user_id !== data.item.last_user_id && data.item.process_status !== 3" @click="view(data.item, 'send')"><i class="ri-share-forward-line m-0"></i></a>
                                            <a href="javascript:" class="btn_table_action btn_purple" :title="$t('grant_budget_management.approve')" v-b-modal.modal-1 v-if="($store.state.Auth.activeRoleId === 1 || $store.state.Auth.authUser.user_id === data.item.last_user_id) &&  data.item.process_status !== 3" @click="view(data.item, 'approve')"><i class="fas fa-check"></i></a>
                                            <b-button v-if="$store.state.Auth.authUser.ssoLogin && data.item.process_status == 1" style="font-size: 12px !important; margin-top:10px" variant="btn btn-xs btn-success" size="sm" @click="finalSave(data.item)" ><i class="fa fa-forward"></i> {{$t('globalTrans.to_nothi')}}</b-button>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                    />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
            <b-modal id="modal-5" size="xl" :title="$t('grant_budget_management.budget_details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                <Details :id="editItemId"/>
            </b-modal>
            <b-modal id="modal-1" size="lg" :title="type==='send'?$t('grant_budget_management.send_note'):$t('grant_budget_management.approve_note')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                <approval-note @load-list="loadData" :id="editItemId" :type="type"/>
            </b-modal>
        </b-row>
    </b-container>
</template>
<script>
import Details from '../budget-preparation/Details'
import ApprovalNote from './Note'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetApprovalListApi, budgetApprovalSendNothi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import moment from 'moment'
import Store from '@/store'

export default {
    mixins: [RouteBasedList],
    components: {
        Details,
        ApprovalNote
    },
    data () {
        return {
            search: {
                org_id: 0,
                fiscal_year_id: 0
            },
            item: null,
            rows: [],
            type: ''
        }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
                { label: this.$t('user_role.organization'), class: 'text-center' },
                { label: this.$t('grant_budget_management.fiscal_year'), class: 'text-center' },
                 { label: this.$t('globalTrans.arrived'), class: 'text-center' },
                 { label: this.$t('globalTrans.status'), class: 'text-center' },
                { label: this.$t('globalTrans.action'), class: 'text-center w-15' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'org_bn' },
                    { key: 'fiscal_year_bn' },
                    { key: 'updated_at' },
                    { key: 'status_bn' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'org_en' },
                    { key: 'fiscal_year_en' },
                    { key: 'updated_at' },
                    { key: 'status_en' },
                    { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        },
        organizationList () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList
        }
    },
    watch: {
    },
    created () {
        this.loadData()
    },
    mounted () {
    },
    methods: {
        searchData () {
            this.loadData()
        },
        view (item, type = '') {
            this.editItemId = item.id
            this.type = type
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
            this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation-add', query: { item: item } })
        },
        loadData () {
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
            RestApi.getData(grantAllowanceServiceBaseUrl, budgetApprovalListApi, params).then(response => {
                if (response.success) {
                    this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                    this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
        getRelationalData (data) {
            const listData = data.map(item => {
                const org = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
                const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
                const processStatus = this.$store.state.GrantAllowanceService.commonObj.budgetProcessList.find(status => status.value === item.process_status)
                const tmpCreatedTime = moment(item.updated_at).startOf('minute').fromNow()
                const evaluationData = {
                    org_bn: org !== undefined ? org.text_bn : '',
                    org_en: org !== undefined ? org.text_en : '',
                    status_bn: processStatus !== undefined ? processStatus.text_bn : '',
                    status_en: processStatus !== undefined ? processStatus.text_en : '',
                    fiscal_year_bn: fiscalYear !== undefined ? fiscalYear.text_bn : '',
                    fiscal_year_en: fiscalYear !== undefined ? fiscalYear.text_en : '',
                    updated_at: tmpCreatedTime !== undefined ? tmpCreatedTime : ''

                }
                return Object.assign({}, item, evaluationData)
            })
            return listData
        },
        finalSave (item) {
            this.toggleStatusCustom2(grantAllowanceServiceBaseUrl, budgetApprovalSendNothi, item)
        },
        toggleStatusCustom2 (baseUrl, uri, item) {
            window.vm.$swal({
                title: window.vm.$t('globalTrans.are_you_sure_forward_to_nothi'),
                showCancelButton: true,
                confirmButtonText: window.vm.$t('globalTrans.yes'),
                cancelButtonText: window.vm.$t('globalTrans.no'),
                focusConfirm: false
            }).then((result) => {
                if (result.isConfirmed) {
                this.changeStatusCustom(baseUrl, uri, item)
                }
            })
        },
        changeStatusCustom (baseUrl, uri, item) {
            Store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
            RestApi.postData(baseUrl, uri, item).then(response => {
                if (response.success) {
                window.vm.$toast.success({
                    title: 'Success',
                    message: 'Data Updated Successfully',
                    color: '#D6E09B'
                })
                } else {
                window.vm.$toast.error({
                    title: 'Error',
                    message: 'Operation failed! Please, try again.'
                })
                }
                Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
            })
        }
    }
}
</script>
